module.exports = __webpack_public_path__ + "img/picture_16.bf3a980b.png";